import React from 'react';

const AzureComparisonSection = ({requstconsultation}) => {
  // Cost data
  const costData = [
  {
    id: 1,
    component: 'Compute Resources',
    azure: '€100',
    hetzner: '€10.99',
    savings: '~89%',
    bgColor: 'bg-white'
  },
  {
    id: 2,
    component: 'Storage Capacity',
    azure: '€10',
    hetzner: '€0',
    savings: '100%',
    bgColor: 'bg-gray-50'
  },
  {
    id: 3,
    component: 'Data Transfer',
    azure: '€290',
    hetzner: '€0',
    savings: '100%',
    bgColor: 'bg-white'
  }
];

  // Savings cards data
  const savingsCards = [
  {
    id: 1,
    percentage: '~100%',
    label: 'Potential Savings',
    title: 'Network Traffic',
    description: 'Reduced outbound traffic costs with included bandwidth.'
  },
  {
    id: 2,
    percentage: '~90%',
    label: 'Potential Savings',
    title: 'Cloud Services',
    description: 'Lower infrastructure expenses for databases, caching, and related services.'
  },
  {
    id: 3,
    title: 'Simple Pricing',
    description: 'Clear and predictable costs without unexpected charges.',
    hasIcon: true
  }
];

  // Arrow Icon
  const ArrowIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="ml-2 w-5 h-5">
      <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 4.5 21 12m0 0-7.5 7.5M21 12H3" />
    </svg>
  );

  // Check Circle Icon
  const CheckCircleIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-8 h-8 text-green-600">
      <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
    </svg>
  );

  return (
    <section id="cost-section" className="py-10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* Header Section */}
        <div className="text-center mb-16">
          <span className="text-blue-600 font-semibold text-sm uppercase tracking-wider">
            Cost Comparison
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mt-2 mb-4 transition-all duration-1000 opacity-100 translate-y-0">
            Azure vs. Hetzner Cost Comparison
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto transition-all duration-1000 delay-200 opacity-100 translate-y-0">
            Estimated infrastructure costs for a typical web application
          </p>
        </div>
        
        {/* Cost Table */}
        <div className="max-w-4xl mx-auto transition-all duration-1000 delay-300 opacity-100 translate-y-0">
          <div className="bg-gradient-to-br from-gray-50 to-gray-100 rounded-2xl overflow-hidden border border-gray-200">
            
            {/* Table Header */}
            <div className="grid grid-cols-4 bg-gray-900 text-white p-4">
              <div className="font-bold">Component</div>
              <div className="font-bold text-center">azure</div>
              <div className="font-bold text-center">Hetzner</div>
              <div className="font-bold text-center text-green-400">Savings</div>
            </div>
            
            {/* Table Rows */}
            {costData.map((item) => (
              <div key={item.id} className={`grid grid-cols-4 p-4 ${item.bgColor} border-b border-gray-200`}>
                <div className="font-medium text-gray-900">{item.component}</div>
                <div className="text-center text-red-600 font-semibold">{item.azure}</div>
                <div className="text-center text-green-600 font-semibold">{item.hetzner}</div>
                <div className="text-center text-green-600 font-bold">{item.savings}</div>
              </div>
            ))}
            
            {/* Table Footer - Total */}
            <div className="grid grid-cols-4 p-4 bg-gray-900 text-white">
              <div className="font-bold">Total / Month</div>
              <div className="text-center text-red-400 font-bold text-xl">~€400</div>
              <div className="text-center text-green-400 font-bold text-xl">€10.99</div>
              <div className="text-center text-green-400 font-bold text-xl">~97%</div>
            </div>
            
          </div>
          
          {/* Notes */}
          <p className="text-sm text-gray-500 mt-4">
             * Infrastructure resources and included features may vary depending on the selected service plan.
          </p>
          <p className="text-xs text-gray-400 mt-2">
Cost estimates are based on publicly available pricing information and representative infrastructure configurations. Actual costs may differ depending on workload requirements, resource utilization, geographic region, and selected services.</p>
          
          {/* Disclaimer */}
          <div className="p-4 rounded-lg border border-gray-200 bg-gray-50 text-gray-600 mt-4" role="note">
            <p className="text-xs leading-relaxed">
              <strong className="text-gray-800">Pricing Information: </strong>
             All pricing examples and cost comparisons are provided for illustrative purposes only. Actual costs depend on your infrastructure requirements, usage patterns, and current provider rates. Please verify the latest pricing and service terms with the respective provider.

            </p>
          </div>
        </div>
        
        {/* CTA Button */}
        <div className="mt-8 text-center">
          <button onClick={requstconsultation} className="inline-flex items-center px-6 py-3 bg-gradient-to-r from-blue-600 to-green-500 text-white font-semibold rounded-lg hover:from-green-600 hover:to-blue-600 transition-all duration-300 shadow-md">
            Request Your azure Cost Assessment
            <ArrowIcon />
          </button>
        </div>
        
        {/* Savings Cards */}
        <div className="mt-12 grid md:grid-cols-3 gap-6 max-w-4xl mx-auto">
          
          {/* Card 1 - Bandwidth */}
          <div className="bg-gradient-to-br from-green-50 to-emerald-50 rounded-xl p-6 border border-green-200">
            <div className="text-3xl font-bold text-green-600 mb-2">{savingsCards[0].percentage}</div>
            <p className="text-xs text-green-600 -mt-1 mb-2">{savingsCards[0].label}</p>
            <h3 className="font-bold text-gray-900 mb-1">{savingsCards[0].title}</h3>
            <p className="text-sm text-gray-600">{savingsCards[0].description}</p>
          </div>
          
          {/* Card 2 - Managed Services */}
          <div className="bg-gradient-to-br from-green-50 to-emerald-50 rounded-xl p-6 border border-green-200">
            <div className="text-3xl font-bold text-green-600 mb-2">{savingsCards[1].percentage}</div>
            <p className="text-xs text-green-600 -mt-1 mb-2">{savingsCards[1].label}</p>
            <h3 className="font-bold text-gray-900 mb-1">{savingsCards[1].title}</h3>
            <p className="text-sm text-gray-600">{savingsCards[1].description}</p>
          </div>
          
          {/* Card 3 - Transparent Pricing */}
          <div className="bg-gradient-to-br from-green-50 to-emerald-50 rounded-xl p-6 border border-green-200">
            <div className="flex items-center gap-2 mb-2">
              <CheckCircleIcon />
            </div>
            <h3 className="font-bold text-gray-900 mb-1">{savingsCards[2].title}</h3>
            <p className="text-sm text-gray-600">{savingsCards[2].description}</p>
          </div>
          
        </div>
        
      </div>
    </section>
  );
};

export default AzureComparisonSection;